import { render, staticRenderFns } from "./PostLikesList.vue?vue&type=template&id=fd85654e&"
import script from "./PostLikesList.vue?vue&type=script&lang=js&"
export * from "./PostLikesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports